module.exports = new __parcel__URL__("gallery_12.63ca1926.jpeg").toString();